class EmailFormatter {
    public formatForPrivacy(email: string): string {
        if (IsNullOrWhiteSpace(email) || !email.contains("@"))
            throw new Error(`Invalid email address: ${email}`);

        const emailParts = email.split("@");
        const emailName = emailParts[0];
        const emailDomain = emailParts[1];
        const firstLetter = emailName[0];
        const lastLetter = emailName[emailName.length - 1];
        const emailNameWithPrivacy = `${firstLetter}*****${lastLetter}`;

        return `${emailNameWithPrivacy}@${emailDomain}`;
    }
}

export { EmailFormatter };
